import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography } from '@mui/material';
import Controls from "../Controls/Controls";

const classes = {
  dialog: {
    padding: 2,
    position: 'absolute',
    top: 5,
    border: 6,
    borderColor: 'red',
    borderRadius: 18,
    color: 'black',
  },

  dialogContent: {
    textAlign: 'center'
  },

  dialogAction: {

  },

  titleIcon: {
    backgroundColor: "#acacac",
  }
}

export default function ConfirmDialog(props) {
  const { confirmDialog, setConfirmDialog } = props;

  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent style={classes.dialogContent}>
        <Typography variant="h6">
          {confirmDialog.title}
        </Typography>
        <Typography variant="subtitle2">
          {confirmDialog.subTitle}
        </Typography>
      </DialogContent>

      <DialogActions style={classes.dialogAction}>
        <Controls.ButtonT
          text="Cancelar"
          variant="outline-secondary"
          onClick={() => {
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            })
          }}
        />

        <Controls.ButtonT
          text="Confirmar"
          variant='outline-success'
          onClick={
            confirmDialog.onConfirm
          }
        />
      </DialogActions>
    </Dialog>
  )
}